import Util from '@dap/shared-utils';
import UtilCache from '@dap/shared-utils/cache';

const dragonflyObj = {
    title: '蜻蜓建站',
    describe: '更高效的落地页物料制作工具，生成的物料源，可快速创建 DAP落地页',
    linkFn: () => {
        const isProd = window.location.hostname === 'dap.lilithgame.com';
        const urlHost = isProd ? 'https://dragonfly-web-ad.lilith.sh' : 'http://dragonfly-web-staging.ad.lilith.sh';

        return `${urlHost}/login?type=1&token=${UtilCache.getLocalItem('token')}&game_id=${Util.getLocalGameId()}`;
    },
    icon: 'qingtingjianzhan',
};

const config = [
    {
        name: '广告投放',
        list: [
            {
                title: '落地页制作',
                describe: '制作用于投放的落地页，提升广告转化效果',
                routerName: 'ToolsLandingPage',
                icon: 'gjk_ladiye',
                oldIcon: 'gjk_ladiye',
                routePath: '/tools/landing-page',
            },
            {
                title: '人群包管理',
                describe: '支持进行人群包的新建、编辑、管理等操作',
                routePath: '/tools/crowd-package/list',
                icon: 'gjk_renqunbao',
            },
            {
                title: '定向包管理',
                describe: '支持进行定向包的新建、编辑、管理等操作',
                routerName: 'ToolsAudiencePackageList',
                params: { spreaderId: 0 },
                icon: 'gjk_dingxiangbao',
                routePath: '/tools/audience-package/list/0',
            },
            {
                title: '关键词包管理',
                describe: '支持进行搜索广告关键词包的新建、编辑、管理等操作',
                routerName: 'ToolsKeywordManagementList',
                params: { spreaderId: 0 },
                icon: 'guanjianciguanli',
                routePath: '/tools/keyword/list',
            },
            {
                title: '账户管家',
                describe: '支持进行推广账户的授权管理、及财务数据查看',
                routerName: 'ToolsAccountStewardList',
                icon: 'gjk_zhanghuguanjia',
                routePath: '/tools/account-steward/main',
            },
            {
                title: '分包管理',
                describe: '支持上传游戏包的管理和分包操作，便于国内投放',
                routerName: 'ToolsSubPackageList',
                icon: 'gjk_fenbaoguanli',
                routePath: '/tools/sub-package',
            },
            // 比较特殊，但已搞定
            {
                title: '素材审核',
                describe: '素材内容审核',
                routerName: 'ToolsArtsAudit',
                icon: 'gjk_fawushenhe',
                routePath: '/tool-list/material-audit/arts',
            },
            {
                title: '测包工具',
                describe: '自动化测包工具',
                routerName: 'ToolsTestPackageList',
                icon: 'gjk_cebaogongju',
                routePath: '/tools/test-package/main',
            },
            {
                title: '客诉工具',
                describe: 'CPE渠道自助客诉工具',
                routerName: 'ToolsCompliantList',
                routePath: '/tools/compliant',
                icon: 'gjk_kesugongju',
            },
            {
                title: '评论管理',
                describe: '抖音&快手评论管理与舆情分析',
                routerName: 'commentsManagement',
                icon: 'pinglunguanli',
                routePath: '/tools/comments-management/douyin',
            },
        ],
    },
    {
        name: '广告优化',
        list: [
            {
                title: '事件优选',
                describe: '一站式推荐、管理、优化事件',
                routerName: 'ToolsEvent',
                icon: 'gjk_shijianyouxuan',
                routePath: '/tools/event',
            },
            // TODO 代码待删除
            // {
            //     title: '智能投放',
            //     describe: '专注于人效和效果提升的智能化投放方案',
            //     routerName: 'SmartSpreader',
            //     icon: 'gjk_zhinengtoufang',
            //     routePath: '/tools/smart-spreader',
            // },
            {
                title: '自动规则',
                describe: '自动监控和优化广告效果，提高广告优化效率',
                routerName: 'ToolsAutoRule',
                icon: 'gjk_zidongguize',
                routePath: '/tools-ad-optimize/auto-rule/list',
            },
            {
                title: '防护墙',
                describe: '多维度分析防作弊数据，真实评价和衡量渠道质量',
                routerName: 'ToolsDefendWall',
                icon: 'fanghuqiang',
                routePath: '/tools/defend',
            },
            {
                title: '刷量分析',
                describe: '展示刷量规则命中效果，分析刷量数据变化趋势',
                routerName: 'ToolsFraudReport',
                icon: 'shualiangfenxi',
                routePath: '/tools/fraud',
            }
        ],
    },
    {
        name: '广告分析',
        list: [
            // {
            //     title: '数据预警',
            //     describe: '支持设置和管理指标预警，查看预警记录以及预警接收组管理',
            //     routerName: 'ToolsEarlyWarningManage',
            //     icon: 'gjk_shujuyujing',
            // },
            {
                title: '数据播报',
                describe: '支持设置报表推送到企业微信，满足用户定时查看关键数据',
                routerName: 'ToolsBroadcast',
                icon: 'gjk_shujubobao',
                routePath: '/tools/broadcast',
            },
            {
                title: '日期标注',
                describe: '支持对特定日期添加活动属性并生成标注，辅助工作表的数据查看',
                routerName: 'ToolsAnnotation',
                icon: 'gjk_riqibiaozhu',
                routePath: '/tools/date-annotation/main',
            },
        ],
    },
    {
        name: '营销工具',
        list: [
            {
                title: '红人馆',
                describe: '支持进行红人信息管理，及活动数据查看',
                routerName: 'ToolsCelebrityCelebrityList',
                icon: 'gjk_hongrenguan',
                routePath: '/tool-list/celebrity/celebrity-list',
            },
        ],
    },
    {
        name: '其他工具',
        list: [
            {
                title: '财务管理',
                describe: '支持进行消耗录入、对账管理、财务结算等操作',
                routerName: 'ToolsFinanceCostInV2',
                icon: 'gjk_caiwuguanli',
                routePath: '/tool-list/finance/cost-in-v2',
            },
            {
                title: '游戏生命周期',
                describe: '查看游戏&游戏包基础信息及生命周期历程，跳转查看对应数据',
                routerName: 'GamePackage',
                icon: 'youxishengmingzhouqi',
                routePath: '/tools/game-package',
            },
            dragonflyObj,
            {
                title: '自助联调工具',
                describe: '支持国内游戏各渠道联调，包括渠道归因、回传配置查看',
                routerName: 'debug',
                icon: 'zizhuliantiaogongju',
                routePath: '/tools/debug/list',
            },
            {
                title: 'VisioAIsta',
                describe: '使用AIGC技术提供模型训练和验证，并支持AI出图',
                routerName: 'aigc',
                icon: 'aigc-AIGC',
                routePath: '/aigc/pic-results',
            },
        ],
    },
];

export const chinaDefaultTool = [
    dragonflyObj,
    {
        title: '落地页制作',
        describe: '制作用于投放的落地页，提升广告转化效果',
        routerName: 'ToolsLandingPage',
        icon: 'gjk_ladiye',
        oldIcon: 'gjk_ladiye',
        routePath: '/tools/landing-page',
    },
    {
        title: '财务管理',
        describe: '支持进行消耗录入、对账管理、财务结算等操作',
        routerName: 'ToolsFinanceCostInV2',
        icon: 'gjk_caiwuguanli',
        routePath: '/tool-list/finance/cost-in-v2',
    },
    {
        title: '自助联调工具',
        describe: '支持国内游戏各渠道联调，包括渠道归因、回传配置查看',
        routerName: 'debug',
        icon: 'zizhuliantiaogongju',
        routePath: '/tools/debug/list',
    },
    {
        title: '素材审核',
        describe: '素材内容审核',
        routerName: 'ToolsArtsAudit',
        icon: 'gjk_fawushenhe',
        routePath: '/tool-list/material-audit/arts',
    },
    {
        title: '账户管家',
        describe: '支持进行推广账户的授权管理、及财务数据查看',
        routerName: 'ToolsAccountStewardList',
        icon: 'gjk_zhanghuguanjia',
        routePath: '/tools/account-steward/main',
    },
];

export const otherDefaultTool = [
    dragonflyObj,
    {
        title: '落地页制作',
        describe: '制作用于投放的落地页，提升广告转化效果',
        routerName: 'ToolsLandingPage',
        icon: 'gjk_ladiye',
        oldIcon: 'gjk_ladiye',
        routePath: '/tools/landing-page',
    },
    {
        title: '红人馆',
        describe: '支持进行红人信息管理，及活动数据查看',
        routerName: 'ToolsCelebrityCelebrityList',
        icon: 'gjk_hongrenguan',
        routePath: '/tool-list/celebrity/celebrity-list',
    },
    {
        title: '客诉工具',
        describe: 'CPE渠道自助客诉工具',
        routerName: 'ToolsCompliantList',
        icon: 'gjk_kesugongju',
        routePath: '/tools/compliant',
    },
    {
        title: '刷量分析',
        describe: '展示刷量规则命中效果，分析刷量数据变化趋势',
        routerName: 'ToolsFraudReport',
        icon: 'shualiangfenxi',
        routePath: '/tools/fraud',
    },
    {
        title: '自助联调工具',
        describe: '支持国内游戏各渠道联调，包括渠道归因、回传配置查看',
        routerName: 'debug',
        icon: 'zizhuliantiaogongju',
        routePath: '/tools/debug/list',
    },
];

export default config;
